(function () {
  function init(scope) {
    const section = scope.querySelector('.product--section') || (scope.matches && scope.matches('.product--section') ? scope : null);
    if (!section || section.dataset.azProductReady) return;
    const source = section.querySelector('[data-section-data]');
    const purchase = section.querySelector('[data-product-form-area]');
    const labelSource = purchase && purchase.querySelector('[data-az-product-labels]');
    if (!source || !purchase || !labelSource) return;
    let product, labels;
    try { product = JSON.parse(source.textContent).product; labels = JSON.parse(labelSource.textContent); } catch (_) { return; }
    if (!product) return;
    section.dataset.azProductReady = 'true';
    const unitInfo = purchase.querySelector('[data-az-unit-kind]');
    const unitKind = unitInfo && unitInfo.dataset.azUnitKind;
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
    });
    function selectedVariant() {
      const selectors = Array.from(purchase.querySelectorAll('select[data-product-option]'));
      const radios = Array.from(purchase.querySelectorAll('input[data-product-option]:checked'));
      const selected = selectors.length ? selectors.map(s => s.value) : radios.map(s => s.value);
      if (selected.length) {
        const match = product.variants.find(v => v.options.every((value, index) => value === selected[index]));
        if (match) return match;
      }
      const idInput = purchase.querySelector('[name="id"]');
      const id = idInput && idInput.value;
      return product.variants.find(v => String(v.id) === String(id)) ||
        product.variants.find(v => String(v.id) === new URLSearchParams(location.search).get('variant')) ||
        product.variants.find(v => v.available) || product.variants[0];
    }
    function updateUnit() {
      if (!unitInfo) return;
      const variant = selectedVariant();
      if (!variant) return;
      const defaultVariant = variant.title === 'Default Title';
      const packageText = defaultVariant ? product.title : variant.title;
      const caseMatch = packageText.match(/\bcase\s+of\s+(\d+)\b/i);
      let title = labels.packageTitle, note = labels.packageNote;
      let detail = defaultVariant ? '' : variant.title;
      if (unitKind !== 'pack' && !caseMatch && /\beach\b/i.test(packageText) && !/\bpack\s+of\b/i.test(packageText)) {
        title = labels.eachTitle; note = labels.eachNote;
      } else if (unitKind === 'bag' && !/\bcase\b|\bpack\s+of\s+\d+/i.test(packageText)) {
        title = labels.bagTitle; note = labels.bagNote;
      } else if (unitKind === 'wet' && caseMatch && Number(caseMatch[1]) > 0) {
        title = labels.caseTitle; note = labels.caseNote;
        const count = Number(caseMatch[1]);
        const can = /canned|\bcans\b/i.test(product.title + ' ' + (product.type || ''));
        detail = (defaultVariant ? labels.caseCount.replace('__COUNT__', String(count)) : variant.title) +
          ' · ' + money.format(variant.price / 100 / count) + ' ' + (can ? labels.perCan : labels.perItem);
      } else if (unitKind === 'pack') {
        title = labels.packTitle; note = labels.packNote;
      }
      unitInfo.querySelector('[data-az-unit-label]').textContent = title;
      unitInfo.querySelector('[data-az-unit-detail]').textContent = detail;
      unitInfo.querySelector('[data-az-unit-note]').textContent = note;
    }
    purchase.addEventListener('change', function () {
      updateUnit();
      if (window.requestAnimationFrame) window.requestAnimationFrame(updateUnit);
    });
    updateUnit();
    if (unitKind === 'wet') {
      purchase.querySelectorAll('.form-field-title, .option-name').forEach(function (label) {
        if (label.textContent.trim().toLowerCase() === 'title') label.textContent = labels.caseOption;
      });
    }
    const description = section.querySelector('[data-az-description]');
    if (!description) return;
    const headings = Array.from(description.children).filter(el => /^H[2-6]$/.test(el.tagName));
    headings.forEach(heading => {
      const normalized = heading.textContent.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/^[^\p{L}\p{N}]+/u, '').trim().replace(/:$/, '').toLowerCase();
      if (!/^(complete ingredients|ingredients|guaranteed analysis|feeding guidelines|feeding & serving|feeding instructions|additional information|calorie content|caloric content|case details|package sizes and selling units|package information)$/.test(normalized)) return;
      const details = document.createElement('details');
      details.className = 'az-product-details';
      const summary = document.createElement('summary');
      const content = document.createElement('div');
      content.className = 'az-product-details-content';
      const nodes = [];
      let next = heading.nextSibling;
      while (next && !(next.nodeType === 1 && /^H[1-6]$/.test(next.tagName))) { nodes.push(next); next = next.nextSibling; }
      heading.replaceWith(details);
      summary.appendChild(heading);
      details.append(summary, content);
      nodes.forEach(node => content.appendChild(node));
    });
    description.querySelectorAll('table').forEach(table => {
      if (table.parentElement.classList.contains('az-table-scroll')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'az-table-scroll';
      wrapper.tabIndex = 0;
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', labels.tableLabel);
      table.replaceWith(wrapper);
      wrapper.appendChild(table);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();

